/* Publish by EComposer at 2025-07-29 14:42:37*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hpp3qguv8io"]=  window.__ectimmers["ecom-hpp3qguv8io"] || {};
if(!this.settings||!this.$el||this.isLive)return;const e=this.$el;let i=e.querySelectorAll('script:not([type="application/json"])');i.length>0&&i.forEach(function(t){let n=document.createElement("script");n.type="text/javascript",n.innerText=t.innerText,t.src&&(n.src=t.src),e.appendChild(n),t.remove()})

                    });
                    
                        document.querySelectorAll('.ecom-hpp3qguv8io').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hpp3qguv8io', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rot0xj47up').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rot0xj47up', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6jaiuewz1uc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6jaiuewz1uc', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-r4zq5oilx6"]=  window.__ectimmers["ecom-r4zq5oilx6"] || {};
if(!this.settings||!this.$el)return;const e=this.$el,i=this.isLive,t=this.settings.loop,n=this.settings.autoplay,s=this.settings.lazyload||!1,o=this.settings.player_controls||!1,a=this.settings.pause_on_hover||!1,r=this.settings.click_to_play_pause,c=this.settings.play_on_lightbox||!1,m=1;let l=e.querySelector(".ecom-video_overlay-icon");const h=e.querySelector(".ecom-video-poster");let y;y=l&&l.querySelector(".ecom-video-icon-play");const g=e.querySelector(".ecom-element_video-iframe");s&&setTimeout(function(){b(g)},500);function b(L){let T={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver($,T).observe(L)}function u(L,T){let M={handleMouseenter:z,handleMouseleave:S,handleEnded:q};function z(){L.readyState>=m&&L.pause()}function S(){L.readyState>=m&&L.play()}function q(){x(L,M)}if(a){L.addEventListener("mouseenter",z),L.addEventListener("mouseleave",S);let P=e.querySelector(".ecom-video_link-extra");P&&P.href&&(P.addEventListener("mouseenter",z),P.addEventListener("mouseleave",S)),T||L.addEventListener("ended",q)}}function x(L,T){if(T){const{handleMouseenter:M,handleMouseleave:z,handleEnded:S}=T;let q=e.querySelector(".ecom-video_link-extra");L.removeEventListener("mouseenter",M),L.removeEventListener("mouseleave",z),L.removeEventListener("ended",S),q&&q.href&&(q.removeEventListener("mouseenter",M),q.removeEventListener("mouseleave",z))}}function $(L,T){L.forEach(function(M){if(M.isIntersecting){const z=M.target.querySelector("video source"),S=M.target.querySelector("video"),q=M.target.querySelector("iframe");if(S&&z&&(z.src=z.dataset.source,S.load(),S.addEventListener("loadeddata",function(){n&&S.play()})),q){let P=q.dataset.srcVideo;q.setAttribute("src",P)}T.unobserve(M.target)}})}let v=e.querySelector(".ecom_video"),w=e.querySelector(".ecom_iframe");r&&v.addEventListener("click",()=>{v.readyState>=m&&(v.paused?v.play():v.pause())}),n&&(l&&l.classList.remove("ecom-overlay"),y&&(y.style.display="none"),h&&(h.style.display="none")),v&&!t&&v.addEventListener("ended",function(){h&&(h.style.display="block"),l&&l.classList.add("ecom-overlay"),y&&(y.style.display="block")}),l&&l.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&v)h&&(h.style.display="none"),v.autoplay=!0,v.play(),l.classList.remove("ecom-overlay"),y.style.display="none";else if(w){let L=w.getAttribute("src");L.includes("autoplay=0")?L=L.replace("autoplay=0","autoplay=1"):L=L+"&autoplay=1",w.setAttribute("src",L),c?setTimeout(()=>{L=L.replace("autoplay=1","autoplay=0"),w.setAttribute("src",L)},100):(h&&(h.style.display="none"),l.classList.remove("ecom-overlay"),y.style.display="none")}}),v&&(i&&!h&&u(v,t),h&&h.addEventListener("click",function(){h.style.display="none",v.play(),i&&u(v,t)}),a||v.addEventListener("pause",function(){h&&(h.style.display="block"),l&&l.classList.add("ecom-overlay"),y&&(y.style.display="block")}),!o&&l&&v.addEventListener("click",function(){v.pause()})),e.querySelectorAll("[data-ec-tracking-id]").forEach(function(L){L.dataset.ecTrackingId&&L.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:L.id,tracking_id:L.dataset.ecTrackingId})},{once:!0})});const f=e.querySelector("[ecom-modal]");if(f&&this.settings.image_overlay&&c&&window.EComModal){const L=f.dataset.width,T=f.dataset.height;var k=this.id;new window.EComModal(f,{cssClass:[k,"ecom-core","ecom-core-simulator"],onOpen:function(){var M=document.querySelector(".ecom-modal."+k);if(M){const z=M.querySelector(".ecom-modal-box__content");z.classList.add("ecom-element_video-iframe");const S={width:L,height:T};Object.assign(z.style,S)}},onClose:function(){var M=document.querySelector(".ecom-modal."+k);if(M){const z=M.querySelector(".ecom-element_video-iframe iframe");z&&(z.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-r4zq5oilx6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r4zq5oilx6', settings: {"loop":true,"autoplay":true,"player_controls":false,"source":"youtube"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-asbf05s1ic7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-asbf05s1ic7', settings: {"autoplay":false,"player_controls":true,"source":"youtube"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-leljwdtzz8"]=  window.__ectimmers["ecom-leljwdtzz8"] || {};
if(!this.$el)return;const e=this.$el;if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var i=this.$el.querySelectorAll("[ecom-modal]");i.length&&new window.EComModal(i,{cssClass:["ecom-container-lightbox-"+this.id]})}if(this.settings.link!=="lightbox"&&this.settings.link!=="custom"&&/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){let t=e.querySelector(".ecom-image-picture-hover"),n=e.querySelector(".ecom-image-picture.ecom-image-has-hover");if(!t||!n)return;t.addEventListener("click",function(){n.classList.add("image-active"),t.classList.add("image-hidden")}),n.addEventListener("click",function(){n.classList.remove("image-active"),t.classList.remove("image-hidden")})}

                    });
                    
                        document.querySelectorAll('.ecom-leljwdtzz8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-leljwdtzz8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46d79gkjvto').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46d79gkjvto', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4y53zspc8kl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4y53zspc8kl', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5d5fdpan1i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5d5fdpan1i', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tsr3zbek3ag"]=  window.__ectimmers["ecom-tsr3zbek3ag"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-tsr3zbek3ag"]["onjxsr7ja"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-tsr3zbek3ag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tsr3zbek3ag', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r2ankez5z8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r2ankez5z8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4d3qfud79xx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4d3qfud79xx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-846p120c826').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-846p120c826', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bvklxar46vr"]=  window.__ectimmers["ecom-bvklxar46vr"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-bvklxar46vr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bvklxar46vr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pxi5s1lgrpr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pxi5s1lgrpr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8edkmnh34s5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8edkmnh34s5', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53d636m6fg7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53d636m6fg7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u07sabxd4dg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u07sabxd4dg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wyraf1ogdc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wyraf1ogdc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b1u1kq6ya8q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b1u1kq6ya8q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p8cff6f9nog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p8cff6f9nog', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fzluvtjzdgw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fzluvtjzdgw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rc0be9i2vhd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rc0be9i2vhd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p6m8rvr1zu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p6m8rvr1zu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dyi8cr01qoi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dyi8cr01qoi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6gwvfggfqnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6gwvfggfqnl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a1slsx953e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a1slsx953e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fzkpbypxxoq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fzkpbypxxoq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b8iuli941ur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b8iuli941ur', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24ixcxd8hik').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24ixcxd8hik', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-09kz9qr4xa8f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-09kz9qr4xa8f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gkqpbbp8op4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gkqpbbp8op4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-s4edw9g58w"]=  window.__ectimmers["ecom-s4edw9g58w"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-s4edw9g58w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s4edw9g58w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0eqvrrfg4n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0eqvrrfg4n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0u9az5lhruu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0u9az5lhruu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-95lvegd6tr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-95lvegd6tr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6qtm0ru8e1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6qtm0ru8e1o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9g8p6fbng6n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9g8p6fbng6n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ijvwjet1mlf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ijvwjet1mlf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j0fb7hzr7bo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j0fb7hzr7bo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9qfqorqz2ua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9qfqorqz2ua', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ur0g2e5tnd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ur0g2e5tnd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e7uqmmkc94').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7uqmmkc94', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qd9wzugsvui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qd9wzugsvui', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1vnwaxmeidy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1vnwaxmeidy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xc6ai7ej0m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xc6ai7ej0m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wdkdxgc1lxp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wdkdxgc1lxp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ne1cbx836fr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ne1cbx836fr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mo2zdw48ew').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mo2zdw48ew', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7mynl51ufti').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7mynl51ufti', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9r05og4j5f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9r05og4j5f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nmhuww1ct49').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nmhuww1ct49', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5bgbs70x2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5bgbs70x2a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vng9iy8geto').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vng9iy8geto', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s9y22l1pzob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s9y22l1pzob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8n6dsjsmwfg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8n6dsjsmwfg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7e1sh4qhxy4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7e1sh4qhxy4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0k47mk7zje8t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0k47mk7zje8t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mxidcjltt1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mxidcjltt1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5n4y2qmda0a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5n4y2qmda0a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-avzznv9g2k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-avzznv9g2k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ir0pw74wed').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ir0pw74wed', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xtti7wumd4d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xtti7wumd4d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zj2o653nvg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zj2o653nvg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cgr5bt6zjfo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cgr5bt6zjfo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ahu6lf2jfja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahu6lf2jfja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-riwvjudi6vc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-riwvjudi6vc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mbisv6kj20c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbisv6kj20c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hnp6bkmjnjv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hnp6bkmjnjv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2hmv9v6fqy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2hmv9v6fqy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v4o0t8p6wwk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v4o0t8p6wwk', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}